
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"44","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.085 17H14.5a.5.5 0 010-1h11.585a1.5 1.5 0 012.83 0h.585a.5.5 0 010 1h-.585a1.5 1.5 0 01-2.83 0zm-9 4.5a1.5 1.5 0 012.83 0H29.5a.5.5 0 010 1h-9.585a1.5 1.5 0 01-2.83 0H14.5a.5.5 0 010-1h2.585zm5 5.5a1.5 1.5 0 012.83 0H29.5a.5.5 0 010 1h-4.585a1.5 1.5 0 01-2.83 0H14.5a.5.5 0 010-1h7.585z","fill":"#fff"}})])
          )
        }
      }
    